import { cityListApi, propertyCategoryApi, PropertyCreateApi, PropertyDeleteApi, PropertyDetailApi, PropertyEditApi, propertyImageListApi, PropertyListApi, propertyOwnerApi, propertyTypeListApi, featureListApi, popularPlaceListApi, getDistrictListApi, getCommuneListApi, getPropertyTypeByCategoryApi } from "../../core/http/httpClient";
import { makeAsyncApiCall } from "../common";
import { takeEveryFsa } from "../operations";
import { propertyActions } from "./actions";

export function* propertySaga() {
  yield takeEveryFsa(propertyActions.fetchProperties.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.fetchProperties, PropertyListApi)
  });

  yield takeEveryFsa(propertyActions.getPropertyDetails.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.getPropertyDetails, PropertyDetailApi)
  });

  yield takeEveryFsa(propertyActions.createNewProperty.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.createNewProperty, PropertyCreateApi)
  });

  yield takeEveryFsa(propertyActions.updateProperty.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.updateProperty, PropertyEditApi)
  });

  yield takeEveryFsa(propertyActions.deleteProperty.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.deleteProperty, PropertyDeleteApi)
  });

  yield takeEveryFsa(propertyActions.getCity.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.getCity, cityListApi)
  });

  yield takeEveryFsa(propertyActions.getDistrict.started, function* (action) {
    const city_id = action.payload.id;
    yield* makeAsyncApiCall(action, propertyActions.getDistrict, getDistrictListApi(city_id));
  });

  yield takeEveryFsa(propertyActions.getCommune.started, function* (action) {
    const districtId = action.payload.id;
    yield* makeAsyncApiCall(action, propertyActions.getCommune, getCommuneListApi(districtId));
  });

  yield takeEveryFsa(propertyActions.getPropertyCategory.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.getPropertyCategory, propertyCategoryApi)
  });

  yield takeEveryFsa(propertyActions.getPropertyImage.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.getPropertyImage, propertyImageListApi)
  });

  yield takeEveryFsa(propertyActions.getPropertyOwner.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.getPropertyOwner, propertyOwnerApi)
  });

  yield takeEveryFsa(propertyActions.getPropertyType.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.getPropertyType, propertyTypeListApi)
  });

  yield takeEveryFsa(propertyActions.getPropertyTypeByCategory.started, function* (action) {
    const categoryId = action.payload.category_id;
    yield* makeAsyncApiCall(action, propertyActions.getPropertyTypeByCategory, getPropertyTypeByCategoryApi(categoryId));
  });

  yield takeEveryFsa(propertyActions.getFeatureList.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.getFeatureList, featureListApi)
  });
  yield takeEveryFsa(propertyActions.getPopularPlaceList.started, function* (action) {
    yield* makeAsyncApiCall(action, propertyActions.getPopularPlaceList, popularPlaceListApi)
  });
}